import styled from 'styled-components'

const GlobalNotificationComponent = styled.div`
  position: sticky;
  bottom: 16px;
  background: #3e9f26;
  color: white;
  padding: 8px 16px;
  text-align: center;
  border-radius: 8px;
  margin: 16px 16px 8px;
  border: 2px solid white;
`

/**
 * サイト全体に表示するお知らせ
 *
 * 以下の２つを設定してください
 * - endDate: お知らせ表示を終了する日付 （休み期間の最終日 + 1日）
 * - text: お知らせのテキスト
 */
const endDate = new Date('2026-01-05')
const text = '年末年始休暇のお知らせ: 2025年12月27日〜2026年1月4日まで休業となります'

export const GlobalNotification = () => {
  if (!endDate || !text) {
    return null
  }

  if (!(new Date() < endDate)) {
    return null
  }

  return <GlobalNotificationComponent>{text}</GlobalNotificationComponent>
}
